export default __webpack_public_path__ + "static/media/aaschen-bold.1c4088bd.otf";